<template>
  <div class="home">
    <Header></Header>

    <!-- 轮播图部分 -->
    <div class="rotationmap" >
      <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="(item,index) in rotationmap" :key="index">
          <img :src="item.url" ref="bannerHeight" @load="imgLoad" class="bannerImg" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 企业优势 -->
  <div class="advantage">
    <div class="advantage-title">
      <p>企业优势</p>
      <p>COEPOEATE ADVANTAGE</p>
    </div>

    <div class="content">
      <ul>
        <li>
          <img src="../assets/home_icon_ssx.png" />
          <p class="title">实时性</p>
          <i></i>
          <p class="word">免除人工抄写流程无需 </p>
          <p class="word"> 电话询问生产进度</p>
          <p class="word">故障维修及时调度通知</p>
        </li>
         <li>
          <img src="../assets/home_icon_zqx.png" />
          <p class="title">正确性</p>
          <i></i>
          <p class="word">生产进度精准了解</p>
          <p class="word">机台自动报工</p>
          <p class="word">避免人工抄写错误</p>
        </li>
        <li>
          <img src="../assets/home_icon_fbx.png" />
          <p class="title">方便性</p>
          <i></i>
          <p class="word">工厂订制化APP</p>
          <p class="word">与企业私有服务器</p>
          <p class="word">连网即可使用</p>
        </li>
        <li>
          <img src="../assets/home_icon_kczx.png" />
          <p class="title">可操作性</p>
          <i></i>
          <p class="word">简单流程轻松操作</p>
          <p class="word">各项功能一按即查</p>
          <p class="word">管理者一目了然</p>
        </li>
      </ul>
    </div>

  </div>

  <!-- 企业简介 -->
  <div class="aboutus">
    <div class="top-out">
      <div class="top">
            <div class="top-left">
              <div class="title">
                <p class="zw">企业简介</p>
                <p class="yw">ABOUT US</p>
              </div>
            
              <p class="left-word">
                苏州弘瀚自动化科技有限公司于2007年成立，公司位于苏州高新区和枫产业园，至今已耕耘于电子业自动化十多年，有着丰富的行业经验和较强的非标自动化系统集成能力。服务据点遍布全国各地，重视研发，拥有78项实用新型专利和8项发明专利。自动化仓储与物流系统、产线自动化设计规划、自动化解决方案、智能设备云系统等多元化产品。公司坚持以崇本务实、发明创新 关怀员工、永续经营为理念，致力于发展为一流的非标自动化设备综合服务企业。
              </p>
            </div>
        
          <img class="top-right" src="../assets/home_img_qyjj2.png">
      </div>
    </div>

    <div class="bottom">
      <ul>
        <li>
          <p>20</p>
          <p>2003年至今，<br>企业已有20年发展历史</p>
        </li>
        <li>
          <p>100+</p>
          <p>自动化领导者，业务遍布<br>全国100+个省市</p>
        </li>
        <li>
          <p>86</p>
          <p>实用新型专利78项，<br>发明专利8项</p>
        </li>
        <li>
          <p>7</p>
          <p>公司目前于合肥、苏州、深圳 、<br> 南京、 宁波、台湾皆有服务据点</p>
        </li>
      </ul>
    </div>
  </div>

  <!-- 产品中心 -->
  <div class="product">
    <el-row :gutter="24">
      <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
      <el-col :span="16">
        <div class="title">
          <div class="left">
            <p>产品中心</p>
            <p>COEPOEATE ADVANTAGE</p>
          </div>
          <div class="right">
            <el-row>
              <router-link to="Product">
                <el-button plain>查看更多</el-button>
              </router-link>
            </el-row>
          </div>
        </div>

        <div class="content">
          <ul>
            <li v-for="(item,index) in ProductList" :key="index">
                <router-link :to="{path: '/ProductDetails', query: {productid: index}}" tag="div">
                  <img :src="require('@/assets/product/' + item.imgprqurl)" />
                  <p>{{item.title}}</p>
                </router-link>
            </li>
 
            <!-- <li v-for="(item,index) in ProductList" :key="index">
                <router-link :to="{path: '/ProductDetails', query: {productid: index}}" tag="div">
                  <img :src="require('@/assets/' + item.imgprqurl)" />
                  <p>{{item.title}}</p>
                </router-link>
            </li> -->
          </ul>
        </div>
      </el-col>

      <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
    </el-row>

    <div class="minde">

      <div class="top">
        <ul class="minde-content">
          <li>
            <router-link :to="{path: '/about', query: {tabid: 2}}" tag="div">
              <img src="../assets/home_icon_fzlc.png">
              <p>发展历程</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path: '/about', query: {tabid: 1}}" tag="div">
              <img src="../assets/home_icon_ryzz.png">
              <p>荣誉资质</p>
            </router-link>
          </li>
          <li>
            <router-link :to="{path: '/about', query: {tabid: 0}}" tag="div">
              <img src="../assets/home_icon_hzhb.png">
              <p>合作伙伴</p>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="bottom">
          <div class="bottombg">
            <div class="left"></div>
          </div>
          <div class="bottomnr">
             <div class="bottomwz">
               <div class="title">
                <p>工业4.0，三个设想</p>
                <p>THREE SCENARIOS</p>
               </div>
               <ul>
                 <li>
                   <p>产品</p>
                   <p>集成有动态数字存储器、感知和通信能力，<br>承载着在其整个供应链和生命 周期中所需<br>的各种必要信息。</p>
                 </li>
                 <li>
                   <p>设施</p>
                   <p>由整个生产价值链所集成，<br>可实现自组织。</p>
                 </li>
                 <li>
                   <p>管理</p>
                   <p>能够根据当前的状况灵活决定生产过程。</p>
                 </li>
               </ul>
             </div>
          </div>
      </div>

    </div>

  </div>
  
  <!-- 企业实力 -->
  <div class="strength">
    <div class="title">
      <p><span>七大</span>据点，见证弘瀚<span>企业实力</span></p>
      <p>公司目前于合肥、苏州、深圳 、南京、 宁波、台湾皆有服务据点</p>
    </div>
    <div class="content-out">

      <img src="../assets/home_img_judian.png" />

      <div class="content">
        <div class="right">
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <img src="../assets/home_icon_point.png" />
                <p>服务据点遍布， 年营业额 约 2000W USD</p>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <img src="../assets/home_icon_point.png" />
                <p>耕耘电子业自动化二十年，经验丰富</p>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <img src="../assets/home_icon_point.png" />
                <p>重视研发，拥有多项专利技术</p>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <img src="../assets/home_icon_point.png" />
                <p>非标自动化系统，集成能力强</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>

  <!-- 行业资讯 -->
  <div class="news">
    <div class="title">
      <p>行业资讯</p>
      <p>INDUSTRY INFORMATION</p>
    </div>

    <div class="top">
      <el-row>
        <el-col :span="24" v-for="(item,index) in newList.slice(0,1)" :key="index">
          <div class="left">
            <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
              <img :src="require('@/assets/news/' + item.topimg)" />
            </router-link>
          </div>

          <div class="right">
            <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
              <p>{{item.title}}</p>
              <p>{{item.date}}</p>
              <p>{{item.substance}}</p>
            </router-link>
            <el-row>
              <router-link :to="{path: 'news'}">
                <el-button plain> 查看更多 </el-button>
              </router-link>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="bottom">
      <ul>
        <li v-for="(item,index) in newList.slice(1,4)" :key="index">
          <router-link :to="{path: '/newsDetails', query: {newid: item.newid}}" tag="div">
            <div class="content">
              <div class="left">
                <p>{{item.dater}}</p>
                <p>{{item.dateny}}</p>
              </div>

              <div class="right">
                <p>{{item.title}}</p>
                <p>{{item.substance}}</p>  
              </div>
            </div>
          </router-link>
        </li>

     
      </ul>
    </div>

  </div>

  <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
// 调用公共组件
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import newlist from '../../static/newlist.js' // 引入

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
  },
  created () {
   const that = this;
   that.newList = newlist.newList[0];
   that.ProductList = newlist.ProductList[0];

   console.log(that.newList)
   console.log(that.ProductList)
},
  data(){
    return {
      rotationmap: [{
        url:require("../assets/banner_img1.png")
      },
      {
        url:require("../assets/banner_img2.png")
      },
      {
        url:require("../assets/banner_img3.png")
      }
      ],
      bannerHeight: '',

      newList: [],
      ProductList: [],
    };
  },

  methods: {
    // 下面的 imgLoad 是页面渲染完成的加载方法，确保屏幕中的图片的高度第一次渲染到页面。
    imgLoad () {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height
        console.log(this.bannerHeight)
      })
    }
  },
// 下面是增加监听事件，当视口发生变化的时候，得到此时图片的高度赋值给 bannerHeight
  mounted () {
      this.imgLoad()
      window.addEventListener('resize', () => {
          this.bannerHeight = this.$refs.bannerHeight[0].height
          this.imgLoad()
      }, false)
  }
}
  
</script>

<style scoped>

  .rotationmap >>> .el-carousel__item img{
    width: 100%;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }

  /* advantage */

 .advantage{
    padding: 90px 0 0 0;
    width: 66.66%;
    margin: 0 auto;
  }

  .advantage-title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .advantage-title p:nth-child(2){
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }

  .advantage .content ul{
    padding-top: 65px;
    display: flex;
    list-style: none;
  }

  .advantage .content ul li{
    box-sizing: border-box;
    width: 320px;
    height: 480px;
    /* background: rgba(255, 255, 255, 0.39);
    box-shadow: 1px 3px 10px rgba(0, 0, 0, 0.2); */
    text-align: center;
  }

  .advantage .content ul li img{
    display: block;
    margin: 80px auto 40px;
    width: 80%px;
  }
  .advantage .content ul li .title{
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #323F4F;
  }
  .advantage .content ul li i{
    display: block;
    width: 40px;
    height: 0px;
    margin: 20px auto;
    border: 1px solid #FFC200;
  }

  .advantage .content ul li .word{
    width: 164px;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #666666;
  }

  /* 企业简介 */

  .aboutus{
    margin-top: 120px;
    /* box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.1); */
  }

  .aboutus .top-out{
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .aboutus .top{
    width: 83.333%;
    height: 720px;
    display: flex;
  }

  .aboutus .top .top-left{
    width: 40%;
    padding-top: 50px;
  }

  .aboutus .top .top-left .title{
    position: relative;
    widows: 300px;
    height: 330px;
  }

  .aboutus .top .top-left .zw{
    position: absolute;
    top: 0;
    left: 70px;
    width: 24px;
    height: 121px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #FFC200;
  }

  .aboutus .top .top-left .yw{
    position: absolute;
    top: 0;
    left: 64px;
    transform:rotate(90deg);
    transform-origin: left top;
    width: 253px;
    height: 64px;
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .aboutus .left-word{
    height: 240px;
    padding-right: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 34px;
    color: #666666;
    text-align: justify;
    /* display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 7;
    overflow: hidden; */
  }


  

  .aboutus .top-right{
    width: 60%;
  }

  .aboutus .bottom{
    width: 66.66%;
    height: 180px;
    margin: 0 auto;
    padding-top: 80px;
  }

  .aboutus .bottom ul{
    display: flex;
    justify-content: space-between;
    width: 100%;
    list-style: none;
  }

  .aboutus .bottom ul li{
    width: 25%;
    height: 120px;
  }

  .aboutus .bottom ul li p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFC200;
  }

  .aboutus .bottom ul li p:nth-child(2){
    padding-right: 15px;
    font-size: 15px;
    font-family: MicrosoftYaHei;
    line-height: 28px;
    color: #666666;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

    @media (max-width: 1400px){ 
    .aboutus .bottom ul li p:nth-child(2){
      font-size: 13px;
    }
  }

    @media (max-width: 1250px){ 
    .aboutus .top .top-left .title{
      height: 300px;
    }
    .aboutus .left-word{
      font-size: 14px;
    } 

  .aboutus .bottom ul li p:nth-child(2){
      font-size: 12px;
    }
    
  }



  /* 产品中心 */

  .product{
    padding-top: 90px;
  }

  .product >>> .el-col{
    display: block;
    margin: 0 auto;
    border: 1px solid transparent;
  }

  .product .title{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .product .title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .product .title p:nth-child(2){
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }
  
  .product .content{
    overflow: hidden;
    margin: 60px 0 100px;
    width: 100%;
    height: 350px;
  }

  .product .content ul{
    overflow: hidden;
    list-style: none;
    width: 4080px;
    height: 330px;
    animation:myfirst1 30s infinite linear;
    -webkit-animation: myfirst 30s infinite linear; /* Safari and Chrome */
  }

  .product .content ul:hover{
    animation-play-state: paused;
    -webkit-animation-play-state: paused; /* Safari 和 Chrome */
  }

  @keyframes myfirst
  {
    0% { transform: translateX(0); }
    100%{ transform: translateX(-2280px); }
  }

  @-webkit-keyframes myfirst /* Safari and Chrome */
  {
    0% { transform: translateX(0); }
    100%{ transform: translateX(-2280px); }
  }
  
  .product .content ul li{
    padding-right: 20px;
    width: 360px;
    height: 330px;
    float: left;
  }

  .product .content ul li:last-child{
    padding-right: 0;
  }

  .product .content ul li img{
    width: 100%;
  }

  .product .content ul li p{
    padding: 15px 0 0 20px;
    text-align: left;
  }

  .product .minde .top{
    display: flex;
    align-items: center;
    width: 100%;
    height: 460px;
    background-image: url(../assets/home_img_kjrk.png);
  }

  .product .minde .top ul{
    display: flex;
    justify-content: space-between;
    width: 56%;
    margin: 0 auto;
    list-style: none;
  }

  .product .minde .top ul li{
    text-align: center;
    width: 33%.33;
  }

  .product .minde .top ul li a{
    text-decoration:none;
  }

  .product .minde .top ul li img{
    width: 75%;
    margin-bottom: 25px;
  }
  .product .minde .top ul li p{
    font-size: 24px;
    font-family: MicrosoftYaHei;
    line-height: 24px;
    color: #FFFFFF;
  }

  .product .minde .bottom{
    position: relative;
    display: block;
    margin-top: 120px;
    width: 100%;
    height: 992px;
    
  }
  
  .product .minde .bottom .bottombg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 992px;
  }

  .product .minde .bottom .bottombg .left{
    float: left;
    width: 49.5%;
    height: 992px;
    background-image: url(../assets/home_img_sgsx.png);
  }

  .product .minde .bottom .bottomnr{
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 992px;
  }

 .product .minde .bottom .bottomnr .bottomwz{
   width: 89%;
   height: 650px;
   background-color: #fff;
 }

 .product .minde .bottom .bottomnr .bottomwz .title{
   width: 410px;
   display: flex;
   flex-flow: wrap;
   float: right;
   padding-top: 130px;
   margin-right: 16.66%;
 }

 .product .minde .bottom .bottomnr .bottomwz > .title p:nth-child(1){
   width: 100%;
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
    margin-bottom: 6px;
 }

 .product .minde .bottom .bottomnr .bottomwz > .title p:nth-child(2){
   width: 100%;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
 }

  .product .minde .bottom .bottomnr .bottomwz ul{
    display: flex;
    justify-content: space-around;
    clear: both;
    list-style: none;
    padding-top: 90px;
  }

  .product .minde .bottom .bottomnr .bottomwz ul li{
    background: #fff;
  }

  .product .minde .bottom .bottomnr .bottomwz ul li p:nth-child(1){
    margin-bottom: 15px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .product .minde .bottom .bottomnr .bottomwz ul li p:nth-child(2){
    padding-right: 15px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }


  /* 企业实力 */

  .strength{
    padding-top: 150px;
  }

  .strength .title{
    text-align: center;
  }

  .strength .title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }

  .strength .title p:nth-child(1) span{
    color: #FFC200;
  }

  .strength .title p:nth-child(2){
    margin-top: 10px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }

  .strength .content-out{
    position: relative;
    margin-top: 55px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* background-image: url(../assets/home_img_judian.png); */
  }

  .strength .content-out > img{
    width: 100%;
  }

  .strength  .content{
    position: absolute;
    left:0px;
    right: 0px;
    top:0px;
    bottom: 0px;
    width: 66.66%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    z-index: 20px;
  }

  .strength .content .left{
    width: 50%;
  }

  .strength .content .left img{
    width: 100%;
  }

  .strength .content .right{
    box-sizing: border-box;
    width: 42%;
    display: flex;
    align-items: center;
  }

  .strength .content .right >>> .grid-content{
    display: flex;
    align-items: center;
    padding-left: 30px;
  }

  .strength .content .right >>> img{
    display: block;
    width: 4.16%;
    margin-right: 12px;
  }

  .strength .content .right >>> p{
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 60px;
    overflow: hidden;
    /* text-overflow:ellipsis; */
    white-space: nowrap;
  }
@media screen and (max-width: 1680px){
  .strength .content .right >>> p{
    font-size: 18px;
  }
}

@media screen and (max-width: 1420px){
  .strength .content .right >>> p{
    font-size: 16px;
  }
}

@media screen and (max-width: 1260px){
  .strength .content .right >>> p{
    font-size: 14px;
  }
}

  /* 行业资讯 */

  .news{
    padding-top: 85px;
  }

  .news .title{
    text-align: center;
  }

  .news .title p:nth-child(1){
    font-size: 48px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #323F4F;
  }

  .news .title p:nth-child(2){
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #DFDFDF;
  }

  .news .top{
    width: 66.66%;
    margin: 90px auto 0;
  }

  .news .top >>> .el-col{
    display: flex;
  }

  .news .top .left{
    width: 40%;
  }

  .news .top .left img{
    width: 100%;
    height: 320px;
  }

  .news .top .right{
    width: 60%;
    padding-left: 45px;
  }

  .news .top .right p:nth-child(1){
    padding-top: 40px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #222222;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }

  .news .top .right p:nth-child(1):hover {
    color: #FFC200;
  }

  .news .top .right p:nth-child(2){
    display: block;
    margin: 15px 0 30px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
  }

  .news .top .right p:nth-child(3){
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #666666;
    text-align: justify;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    cursor: pointer;
  }

  .news .top .right >>> .el-button{
    margin-top: 20px;
    border-radius: 10px;
  }

  .news .top .right >>> a{
    text-decoration: none;
    color: #222;
  }

  .news .bottom{
    width: 66.66%;
    margin: 0 auto;
  }

  .news .bottom ul{
    list-style: none;
  }

  .news .bottom ul li{
    height: 300px;
    border-bottom: 1px solid #BFBFBF;
    display: flex;
    align-items: center;
  }

  .news .bottom ul li .content{
    width: 100%;
    height: 200px;
    cursor:pointer;
  }

  .news .bottom ul li .content:hover{
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  }

  .news .bottom ul li .content .left{
    float: left;
    box-sizing: border-box;
    width: 200px;
    height: 200px;
    margin-right: 55px;
  }

  .news .bottom ul li .content:hover .left{
    background-color: #FFC200;
  }

  .news .bottom ul li .left p:nth-child(1){
    padding-top: 35px;
    text-align: center;
    font-size: 72px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  .news .bottom ul li .left p:nth-child(2){
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }

  .news .bottom ul li .content:hover .left p{
    color: #FFFFFF;
  }

  .news .bottom ul li .right p:nth-child(1){
    padding-top: 30px;
    margin: 0 0 24px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .news .bottom ul li .content:hover .right p:nth-child(1){
    color: #FFC200;
  }

  .news .bottom ul li .right p:nth-child(2){
    padding-right: 100px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    text-align: justify;
    color: #999999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }




</style>


// WEBPACK FOOTER //
// src/views/Home.vue